import { Link } from "react-router-dom";

export default function BrandLogo({ to = "/", className = "", imageClassName = "h-11 w-auto", ...props }) {
  const logo = (
    <img
      src="/images/maiky-logo.png"
      alt="MAIKY"
      width="781"
      height="315"
      className={`${imageClassName} object-contain`}
    />
  );

  if (!to) return <span className={`inline-flex items-center ${className}`} {...props}>{logo}</span>;

  return (
    <Link to={to} className={`inline-flex items-center ${className}`} aria-label="Ir al inicio de MAIKY" {...props}>
      {logo}
    </Link>
  );
}
